import { DownOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu } from 'antd'
import React, { useState } from 'react'

export const locationOptions = [
  {
    key: '2036',
    value: 'ausd',
    text: 'Australian Dollar $',
    country: 'Australia',
    countryCode: 'AU',
    currencySymbol: '$',
    currencyCode: 'AUD',
  },
  {
    key: '2124',
    value: 'cnd',
    text: 'Canadian Dollar $',
    country: 'Canada',
    countryCode: 'CA',
    currencySymbol: '$',
    currencyCode: 'CAD',
  },
  // {
  //     key: '2276',
  //     value: 'geuro',
  //     text: 'Germany Euro €',
  //     country: 'Germany',
  //     countryCode: 'DE',
  //     currencySymbol: '€',
  //     currencyCode: 'EUR',
  // },
  {
    key: '2356',
    value: 'inr',
    text: 'Indian Rupee ₹',
    country: 'India',
    countryCode: 'IN',
    currencySymbol: '₹',
    currencyCode: 'INR',
  },
  {
    key: '2702',
    value: 'sgd',
    text: 'Singapore Dollar $',
    country: 'Singapore',
    countryCode: 'SG',
    currencySymbol: '$',
    currencyCode: 'SGD',
  },
  {
    key: '2784',
    value: 'dirham',
    text: 'UAE Dirham د.إ',
    country: 'United Arab Emirates',
    countryCode: 'AE',
    currencySymbol: 'د.إ',
    currencyCode: 'AED',
  },
  {
    key: '2826',
    value: 'pound',
    text: 'UK Pound £',
    country: 'Uited Kingdom',
    countryCode: 'UK',
    currencySymbol: '£',
    currencyCode: 'GBP',
  },
  {
    key: '2840',
    value: 'usd',
    text: 'US Dollar $',
    country: 'Unites States',
    countryCode: 'US',
    currencySymbol: '$',
    currencyCode: 'USD',
  },
  {
    key: '2458',
    value: 'myr',
    text: 'Malaysian Ringgit RM',
    country: 'Malaysian Ringgit',
    countryCode: 'MY',
    currencySymbol: 'RM',
    currencyCode: 'MYR',
  },
  {
    key: '2360',
    value: 'idr',
    text: 'Indonesian Rp',
    country: 'Indonesia',
    countryCode: 'ID',
    currencySymbol: 'Rp',
    currencyCode: 'IDR',
  },
  {
    key: '2554',
    value: 'nzd',
    text: 'New Zealand $',
    country: 'New Zealand',
    countryCode: 'NZ',
    currencySymbol: '$',
    currencyCode: 'NZD',
  },
]

const LocationDropdown = (props) => {
  const { defaultValue, onChange } = props
  const [value, setValue] = useState(
    defaultValue ? defaultValue : locationOptions[6],
  )
  const onClickMenu = (item) => {
    // console.log("item:", item)
    setValue(item)
    onChange(item)
  }

  return (
    <div className="currency-wrapper text-center">
      <div className="">
        <label className="currency-label">Currency/Country</label>
        <Dropdown
          overlay={
            <Menu>
              {locationOptions.map((item, key) => (
                <Menu.Item key={key} onClick={() => onClickMenu(item)}>
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    {item.text}
                    <div>
                      <img
                        src={`/country/${item.countryCode.toLowerCase()}.png`}
                        alt={item.countryCode}
                        style={{ marginRight: '0' }}
                      />
                    </div>
                  </div>
                </Menu.Item>
              ))}
            </Menu>
          }
          placement="bottomLeft"
          arrow
          className="currency-dropdown"
        >
          {/* <Button>{value.text} <DownOutlined style={{ float: 'right', marginTop: '6px' }} /></Button> */}
          <Button>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                margin: '-1px',
              }}
            >
              {value.text}
              <div style={{}}>
                <img
                  src={`/country/${value.countryCode.toLowerCase()}.png`}
                  alt={value.countryCode}
                  style={{ marginRight: '5px' }}
                />
                <DownOutlined style={{ float: 'right', marginTop: '6px' }} />
              </div>
            </div>
          </Button>
        </Dropdown>
      </div>
    </div>
  )
}

export default LocationDropdown
